// extracted by mini-css-extract-plugin
export default {"productGallery":"FK-z","inQuickShop":"GK-z"};